import { Component, EventEmitter, Input, Output } from "@angular/core";
import { ButtonModule } from "primeng/button";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { DialogModule } from "primeng/dialog";
import { GenericButtonComponent } from "../generic-button/generic-button.component";

@Component({
    selector: 'rc-generic-confirmation', 
    standalone: true,
    imports:
    [
    DialogModule,
    ConfirmDialogModule,
    ButtonModule,
    GenericButtonComponent
],
    templateUrl: './generic-confirmation.component.html',
    styleUrl: './generic-confirmation.component.scss'
})
export class GenericConfirmationComponent {
    @Input() visible: boolean = false;
    @Input() title: string = '';
    @Input() message: string = '';
    @Input() confirmText: string = 'Ok';
    @Input() cancelText: string = 'Cancel';
    @Input() dataObject: any = {};

    @Output() onCancel = new EventEmitter<any>();
    @Output() onConfirm = new EventEmitter<any>();

    onCancelClicked() {
        this.onCancel.emit();
    }

    onConfirmClicked() {
        this.onConfirm.emit(this.dataObject);
    }
}